// Photo Booth Prefill - Handles Easybooth booking data
(function() {
  'use strict';

  console.log('📸 Easybooth Photo Booth Prefill loaded');

  // ------------------------------------------------------------
  // 1. Read URL parameters coming from the Booking Validator
  // ------------------------------------------------------------
  function getUrlParams() {
    var params = {};
    var searchParams = new URLSearchParams(window.location.search);

    searchParams.forEach(function(value, key) {
      params[key] = value;
    });

    return params;
  }

  var params = getUrlParams();

  // ------------------------------------------------------------
  // 2. Save the complete booking information
  // ------------------------------------------------------------
  if (
    params.start_date ||
    params.end_date ||
    params.time ||
    params.duration ||
    params.quantity
  ) {
    sessionStorage.setItem('auto_booking', JSON.stringify(params));

    if (params.time) {
      sessionStorage.setItem('easybooth_delivery_time', params.time);
    }

    console.log('✅ Easybooth booking data saved:', params);
    console.log('🕐 Selected delivery time:', params.time || 'none');
  }

  // ------------------------------------------------------------
  // 3. Get selected delivery time
  // ------------------------------------------------------------
  function getDeliveryTime() {
    var urlParams = new URLSearchParams(window.location.search);
    var timeFromUrl = urlParams.get('time');

    if (timeFromUrl) {
      sessionStorage.setItem('easybooth_delivery_time', timeFromUrl);
      return timeFromUrl;
    }

    return sessionStorage.getItem('easybooth_delivery_time') || '';
  }

  // ------------------------------------------------------------
  // 4. Attach Delivery Time to the REAL Shopify product form
  // ------------------------------------------------------------
  function attachDeliveryTimeToProductForm() {
    var deliveryTime = getDeliveryTime();

    if (!deliveryTime) {
      console.warn('⚠️ Easybooth: no delivery time found.');
      return;
    }

    var forms = document.querySelectorAll(
      'form[action*="/cart/add"], form[data-type="add-to-cart-form"]'
    );

    if (!forms.length) {
      return;
    }

    forms.forEach(function(form) {
      var input = form.querySelector(
        'input[name="properties[Delivery Time]"]'
      );

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Delivery Time]';
        input.setAttribute('data-easybooth-delivery-time', 'true');
        form.appendChild(input);
      }

      input.value = deliveryTime;
    });

    console.log(
      '✅ Easybooth Delivery Time attached to Shopify:',
      deliveryTime
    );
  }

  // ------------------------------------------------------------
  // 5. Initial installation
  // ------------------------------------------------------------
  function initializeDeliveryTime() {
    attachDeliveryTimeToProductForm();

    // IzyRent can modify/rebuild parts of the product form after load.
    // Re-check briefly after initialization.
    setTimeout(attachDeliveryTimeToProductForm, 250);
    setTimeout(attachDeliveryTimeToProductForm, 750);
    setTimeout(attachDeliveryTimeToProductForm, 1500);
    setTimeout(attachDeliveryTimeToProductForm, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeDeliveryTime,
      { once: true }
    );
  } else {
    initializeDeliveryTime();
  }

  // ------------------------------------------------------------
  // 6. Last check immediately before Shopify/IzyRent submission
  // ------------------------------------------------------------
  document.addEventListener(
    'submit',
    function(event) {
      var form = event.target;

      if (!(form instanceof HTMLFormElement)) return;

      if (
        form.matches('form[action*="/cart/add"]') ||
        form.matches('form[data-type="add-to-cart-form"]')
      ) {
        attachDeliveryTimeToProductForm();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function(event) {
      if (!(event.target instanceof Element)) return;

      var button = event.target.closest(
        '.product-form__submit, [name="add"], #continue-booking-btn'
      );

      if (!button) return;

      attachDeliveryTimeToProductForm();
    },
    true
  );

})();